import { SxProps, Theme } from "@mui/material";
import { AdjustmentTypeEnum } from "helpers/types";

export const strategyStyles = {
  adjustmentDataGrid: {
    "& .MuiDataGrid-cell": {
      whiteSpace: "normal !important",
      overflow: "visible",
      textOverflow: "unset",
      alignItems: "center",
      py: 1,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: 1.2,
    },
    "& .MuiDataGrid-columnHeader": {
      height: "unset !important",
    },
    "& .MuiDataGrid-columnHeaders": {
      maxHeight: "none !important",
    },
  } as SxProps<Theme>,
};

export const getAdjustmentTypeColor = (
  adjustmentType: AdjustmentTypeEnum,
): string => {
  if (adjustmentType === AdjustmentTypeEnum.INCEPTION) {
    return "warning.main";
  }

  if (adjustmentType === AdjustmentTypeEnum.BUY) {
    return "success.main";
  }

  if (adjustmentType === AdjustmentTypeEnum.SELL) {
    return "error.main";
  }

  return "text.primary";
};
